import React from 'react';
import ProjexLayout from './components/layout/ProjexLayout';

const Projex = () => {
  return (
    <ProjexLayout />
  );
};

export default Projex; 